import _ from 'lodash';

/* @ngInject */
export default function LicensesUtilityFactory(moment, LicenseRejectReasons, LicenseTypes, LicenseIntegrationTypes) {
    return {
        getStreetAddress,
        getCityState,
        getOwnerNames,
        getLicenseType,
        getRegjectionMsg,
        isDateEmpty,
        licenseExists,
        validate,
        validateExpirationDate,
        validateLicenseExists,
    };

    function getStreetAddress(bizInfo) {
        let address = '';

        address += bizInfo.Address1;

        if (bizInfo.Address2 !== '') {
            address += ` ${bizInfo.Address2}`;
        }

        return address;
    }

    function getCityState(bizInfo) {
        return `${bizInfo.City}, ${bizInfo.State} ${bizInfo.Zip}`;
    }

    function getOwnerNames(owners, stateId) {
        const names = [];


        switch (stateId) {
        case 6:
            _.each(owners, (owner) => {
                let name = `${owner.FirstName}`;

                if (owner.hasOwnProperty('MiddleName') && owner.MiddleName !== '') {
                    name += ` ${owner.MiddleName}`;
                }

                name += ` ${owner.LastName}`;

                names.push({
                    Name: name,
                });
            });
            break;
        case 12:
            _.each(owners, (owner) => {
                // var nomes = owner.Licensee.split(',');
                // var name = '' + nomes[1].trim() + " " + nomes[0].trim();
                names.push({
                    Name: owner.Licensee,
                });
            });
            break;
        default:
            break;
        }


        return names;
    }

    function getRegjectionMsg(rejectionId, data) {
        let msg = data.RejectReason && data.Messages ? data.Messages.length > 0 ? data.Messages[0] : null : null;

        if (!msg) {
            switch (rejectionId) {
            case LicenseRejectReasons.Duplicate.Id:
                msg = LicenseRejectReasons.Duplicate.Msg;
                break;
            case LicenseRejectReasons.NotUnique.Id:
                if (angular.isUndefined(data.Messages)) {
                    msg = LicenseRejectReasons.NotUnique.Msg;
                }
                break;
            default:
                msg = LicenseRejectReasons.LicenseNotValid.Msg;
                break;
            }
        }

        return msg;
    }

    function licenseExists(licenseNumber, licenses) {
        const filtered = _.filter(licenses, license => license.LicenseNumber === licenseNumber);

        return filtered.length > 0;
    }

    function validate(licenseType, licenseNumber, expiration) {
        if (licenseType && licenseType.LicenseCategoryTypeId) {
            // License is not required
            return true;
        }

        return validateLB(licenseNumber, expiration);
    }

    function validateExpirationDate(expiration) {
        const today = moment().format('YYYY-MM-DD');
        const expireDate = moment(convertToDate(expiration));
        return !expiration || (expireDate.isValid() && expireDate.isAfter(today, 'day'));
    }

    function getLicenseType(licenseCategoryTypeId) {
        let licenseType = '';

        switch (licenseCategoryTypeId) {
        case LicenseTypes.Contractor:
            licenseType = 'contractor license.';
            break;
        default:
            licenseType = 'business license.';
            break;
        }

        return licenseType;
    }

    function isDateEmpty(date) {
        if (!date || angular.isUndefined(date)) {
            return true;
        } else if (date.length < 8) {
            return true;
        }
        return false;
    }

    /* private functions */

    function convertToDate(expirationDate) {
        if (!expirationDate || expirationDate.length < 8) {
            return null;
        }

        if (expirationDate.length === 10) {
            const exp = expirationDate.split('-');
            const exp2 = expirationDate.split('/');

            return exp.length > 1 ? `${exp[exp.length - 1]}-${exp[0]}-${exp[exp.length - 2]}` : `${exp2[exp2.length - 1]}-${exp2[0]}-${exp2[exp2.length - 2]}`;
        }

        if (expirationDate.length === 8) {
            return `${expirationDate.substring(4)}-${expirationDate.substring(0, 2)}-${expirationDate.substring(2, 4)}`;
        }

        return expirationDate;
    }

    function validateLB(licenseNumber, expiration) {
        return licenseNumber && validateExpirationDate(expiration);
    }

    /* function validateDocument(document) {
        if (document.DocumentType !== LicenseAttachmentTypes.BusinessLicense) {
            return false;
        }
        if (angular.isUndefined(document.FileName) || document.FileName === null || document.FileName === '') {
            return false;
        }
        if (angular.isUndefined(document.Url) || document.Url === null || document.Url === '') {
            return false;
        }

        return true;
    } */

    function validateLicenseExists(edit, license, licenses) {
        const exists = _.filter(licenses, l =>
            l.LicenseNumber.toUpperCase() === (license.licenseNumber || '').toUpperCase(), // l.OrganizationLicenseTypeId === license.licenseTypeId;  //l.LicenseNumber === license.licenseNumber && l.StateGeoId === license.stateId
        );

        if (exists.length === 0) {
            return true;
        }

        const isUnique = _.filter(exists, e => e.OrganizationLicenseTypeId === license.licenseTypeId);

        if (edit && isUnique.length > 0) {
            const isSame = _.filter(isUnique, u => u.OrganizationLicenseId === license.licenseId && u.LicenseNumber.toUpperCase() === license.licenseNumber.toUpperCase());

            return isSame.length === 1;
        }


        return isUnique.length === 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/licenses/licensesUtilityFactory.js